<template>
	<div class="field">
		<div class="distwrap">
			<label for="distance">Strecke:</label>
			<div class="value">{{distance}} km</div>
		</div>
		<input type="range" class="slider" min="0" :max="sliderValueMax" v-model="sliderValue" @change="changeDistance" />
	</div>
</template>

<script>
import config from '../config';

export default {
	data () {
		return {
			sliderValueMax: this.getSliderValueMax(),
			sliderValue: config.distanceSliderDefault
		}
	},
	computed: {
		distance() {
			return this.getDistance(this.sliderValue);
		}
	},
	methods: {
		changeDistance() {
			this.$store.commit('setDistance', {distance: this.distance});
			this.$store.dispatch('updatePrices');
		},
		getSliderValue(distance) {
			return distance;
		},
		getDistance(sliderValue) {
			const steps = config.distanceSliderSteps;
			let result = 0;
			let counter = 0;
			for (let sg=0; sg<steps.length; sg++) {
				for (let sl=0; sl<steps[sg][0]; sl++) {
					counter++;
					if (counter > sliderValue) break;
					result += steps[sg][1];
				}
				if (counter > sliderValue) break;
			}
			return result;
		},
		getSliderValueMax() {
			return config.distanceSliderSteps.reduce(
				(accumulator, current) => accumulator + current[0],
				0
			);
		}
	},
	mounted() {
		this.$store.commit('setDistance', {distance: this.distance});
	}
}
</script>

<style scoped lang="scss">

.distwrap {
	display: flex;
	justify-content: space-between;
}

.value {
	color: $color-value;
	font-weight: bold;
	float: right;
}

.slider {
	-webkit-appearance: none;
	appearance: none;
	width: 100%;
	height: 40px;
	border: 1px solid $color-input-border;
	outline: none;
	opacity: 1;
	-webkit-transition: .2s;
	transition: opacity .2s;
	padding: 0;
	margin: 0;
	border-radius: 15px;
}

.slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 32px;
	height: 32px;
	background-color: $color-button;
	background-image: url('../assets/icon-arrow-left.svg'), url('../assets/icon-arrow-right.svg');
	background-repeat: no-repeat;
	background-position-y: 10px;
	background-position-x: 6px, 19px;
	background-size: 8px;
	cursor: pointer;
	border-radius: 15px;
	&:hover {
		background-color: $color-button-hover;
	}
}

.slider::-moz-range-thumb {
	width: 32px;
	height: 32px;
	background-color: $color-button;
	background-image: url('../assets/icon-arrow-left.svg'), url('../assets/icon-arrow-right.svg');
	background-repeat: no-repeat;
	background-position-y: 10px;
	background-position-x: 6px, 19px;
	background-size: 8px;
	cursor: pointer;
	border-radius: 15px;
	border-width: 0;
	&:hover {
		background-color: $color-button-hover;
	}
}
</style>
